// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"9c108611","507":"e6629061","583":"a881bbc4","592":"1e04a4c9","971":"3cde9129"}[chunkId] + ".css";
};